import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ImageOff } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export function usePublishedProjects() {
  const [projects, setProjects] = useState(null);
  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);
  return projects;
}

const ProjectCard = ({ p, i }) => (
  <Reveal delay={i * 0.05}>
    <div className="group bg-white border border-gray-200 rounded-sm overflow-hidden h-full hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-200" data-testid={`ref-project-${p.id}`}>
      <div className="aspect-[4/3] bg-gray-100 overflow-hidden">
        {p.image_url ? (
          <img src={p.image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300"><ImageOff size={40} /></div>
        )}
      </div>
      <div className="p-6">
        {p.location && <span className="text-xs font-semibold uppercase tracking-widest text-[#FF5A00]">{p.location}</span>}
        <h3 className="mt-2 text-lg font-bold text-gray-900">{p.title}</h3>
        {p.description && <p className="mt-2 text-gray-600 text-sm leading-relaxed">{p.description}</p>}
      </div>
    </div>
  </Reveal>
);

/** Homepage section: renders nothing until at least one project is published. */
export const ProjectsHomeSection = () => {
  const projects = usePublishedProjects();
  if (!projects || projects.length === 0) return null;

  return (
    <section className="py-20 lg:py-28" data-testid="home-references">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[#FF5A00] font-semibold text-sm uppercase tracking-widest">Referencer</span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">Udvalgte projekter</h2>
        </Reveal>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {projects.slice(0, 6).map((p, i) => <ProjectCard key={p.id} p={p} i={i} />)}
        </div>
        <div className="mt-12">
          <Link to="/referencer" data-testid="home-references-link" className="inline-flex items-center gap-2 font-semibold text-[#FF5A00] hover:gap-3 transition-all">
            Se alle referencer <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export { ProjectCard };
